const formatted = (dateString) => {
    if (!dateString) return '';

    // Convertir la chaîne en Date
    const date = new Date(dateString);

    // Formater la date au format "Décembre 2012"
    return new Intl.DateTimeFormat('fr-FR', { month: 'long', year: 'numeric' }).format(date);
};

const FormattedDate = ({ date }) => {
    return formatted(date);
};

export default FormattedDate; 
